<div class="uk-grid">
  <div class="uk-width-1-1 navbar">
    <p class="nav-text">
      {{'tracking_re'|translate}}
      <button
        class="uk-button uk-button-primary padding-horizontal-small uk-float-right uk-margin-small-top uk-margin-small-right"
        (click)="onChangeLanguage('pl')"
        [attr.uk-tooltip]="'PL'"
      >
        <img src="/assets/img/poland.png"
             alt="Poland"
             style="width: 20px;"
        >
      </button>
      <button class="uk-button uk-button-primary padding-horizontal-small uk-float-right uk-margin-small-top "
              (click)="onChangeLanguage('ro')"
              [attr.uk-tooltip]="'RO'"
      >
        <img src="/assets/img/romania.png"
             alt="Romania"
             style="width: 20px;"
        >
      </button>
    </p>
  </div>

  <div class="uk-width-1-1 uk-margin-medium-top">
    <div class="uk-container uk-margin-auto">
      <div class="uk-first-column uk-margin-top" style="margin: 0 auto; max-width: 800px">
        <div class="uk-card uk-card-default uk-card-body uk-margin-medium-right">

          <div class="uk-text-center uk-margin-bottom">
            <img src="assets/img/re-logo.png" class="img-fluid" routerLink="/">
          </div>

          <form class="" #parcelForm="ngForm" (ngSubmit)="searchShipmentHistory(internalWaybill)">

            <div class="uk-alert uk-alert-danger" *ngIf="false === exists">
              {{"parcel_search_error" | translate}}
            </div>

            <div class="uk-alert uk-alert-danger" *ngIf="statusesEmpty">
              {{"parcel_tracking_empty" | translate}}
            </div>

            <div>
              <label>{{'parcel_number' | translate}}</label>
              <input name="number" class="uk-input" type="text" required [(ngModel)]="internalWaybill">
            </div>

            <div class="uk-margin-top">
              <button [disabled]="!parcelForm.valid" type="submit" class="uk-button uk-button-primary uk-width-1-1">
                <span *ngIf="parcelHistoryObjects.length == 0">{{'search' | translate}}</span>
                <span *ngIf="parcelHistoryObjects.length > 0">{{'search_next' | translate}}</span>
              </button>
            </div>

          </form>

          <div class="uk-grid mt-23" style="margin-left: 5px">
            <app-shipment-card-button
              *ngFor="let object of parcelHistoryObjects"
              class="uk-width-1-4 uk-padding-remove-horizontal"
              [text]="object.waybill"
              title="Historia przesyłki {{object.waybill}}"
              [cardName]="object.waybill"
              [activeCardName]="activeCardName"
              (buttonClicked)="activeCardChanged($event)"
              [hidden]="parcelHistoryObjects.length == 1"
            >
            </app-shipment-card-button>
          </div>

          <app-parcel-history-view
            *ngFor="let object of parcelHistoryObjects"
            [hidden]="object.waybill !== activeCardName"
            [history]="object.history"
            [parcelId]="object.parcel_id"
            [isAdmin]="false"
            [language]="activeLanguage"
          >
          </app-parcel-history-view>

        </div>
      </div>
    </div>
  </div>
</div>
